import { reportFilterWrapper, SelectColumnFilter } from "helpers/reactTable";
import { columnName, formatValue, typeSpecificProps } from "helpers/reports";
import { alphabeticalSort } from "helpers/system";
import React from "react";
import { list as driversList } from "sources/books/drivers";
import GroupedByLogistReport from "./groupedByLogistReport";

export default class DriversReport extends GroupedByLogistReport {
    cellProps = (column) => {
        return {
            Header: column.label,
            accessor: columnName(column),
            Cell: (props) => {
                const { driverId } = props.row.values;
                const uniqueId = { [`data-${props.column.id}`.toLowerCase()]: driverId };
                switch (props.column.id) {
                    case "driverId": {
                        const driverName = props.row.values.driverDisplayName;
                        return <span data-driver-id={props.value}>{driverName}</span>;
                    }
                    default:
                        return (
                            <div className="long-text" {...uniqueId}>
                                {formatValue(props.value, column.clrType)}
                            </div>
                        );
                }
            },
            ...typeSpecificProps(column),
            ...(column.propertyName === "DriverId"
                ? {
                      filter: (rows, _id, filterValue) => {
                          if (!filterValue || !filterValue?.value) {
                              return rows;
                          }
                          const value = filterValue.value;
                          return rows.filter((row) => row.values[filterValue.id] === value);
                      },
                      Filter: reportFilterWrapper((props) => (
                          <SelectColumnFilter
                              {...props}
                              selectProps={{
                                  url: driversList,
                                  inputProps: { name: "driverId" },
                                  propName: "user.fullName",
                                  filterPropName: "user/fullName",
                              }}
                          />
                      )),
                      sortType: (rowA, rowB) => alphabeticalSort(rowA.values, rowB.values, "driverDisplayName"),
                  }
                : {}),
        };
    };

    extractColumns = () => {
        const { columns } = this.props.data || {};
        return columns.map((column) => {
            if (column.propertyName === "DriverId") {
                column.label = "Водитель";
            }
            return this.cellProps(column);
        });
    };

    tableExtraProps = () => {
        const { columns } = this.props.data || {};
        const hiddenColumns = columns
            .filter(
                (column) =>
                    column.isAdditionalColumn ||
                    column.isFooterData ||
                    column.isSubGroup ||
                    column.propertyName === "DriverDisplayName",
            )
            .map(columnName);
        return {
            initialState: {
                hiddenColumns,
            },
        };
    };
}
